import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as outcomes from '../../outcomes'

export const RESOURCE = {
  payload: {
    description:
      'A high-level outcome that the institution is striving towards',
    dimension: outcomes.RESOURCE.payload,
    level: 1,
    name: 'Goal',
    partialId: PartialId.Standard.create('goal'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
